import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-cell-codebarre-link',
    templateUrl: './cell-codebarre-link.component.html',
    styleUrls: ['./cell-codebarre-link.component.scss'],
    standalone: false
})
export class CellCodebarreLinkComponent implements OnInit {
  
  @Input() code: string;
  // Affects font-size of the <i> element
  @Input() size: string = '16px';

  constructor() {}
  
  ngOnInit(): void {
    
  }

}

